import { string } from 'prop-types';
import React from 'react';

function OwnerChange({ valueBefore, valueAfter }) {
  if (valueBefore) {
    return (
      <div>
        {valueBefore} handed over ownership to {valueAfter}.
      </div>
    );
  }
  return <div>{valueAfter} took ownership.</div>;
}
OwnerChange.propTypes = {
  valueAfter: string.isRequired,
  valueBefore: string,
};
OwnerChange.defaultProps = {
  valueBefore: '',
};

export default OwnerChange;
